var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 98,
    viewBox: "0 0 292 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -67.8693,
    y: -67.8693,
    width: 427.739,
    height: 233.739
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(33.93px)",
      clipPath: "url(#bgblur_0_5953_7146_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 67.8693,
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)",
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.3552 27C94.4146 27 91.7191 28.3234 90.2693 30.4547L71.8668 57.25H58.1485V71H76.6068C79.5264 71 82.2239 69.6883 83.6825 67.5597L102.052 40.75H115.733V27H97.3552Z",
    fill: "#1A5AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1035 71L34 64.1421L56.9918 30.4547C58.4325 28.3234 61.1113 27 64.0335 27H82.2969V40.75H68.7008L48.1035 71Z",
    fill: "#1A5AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8576 27V41.1429C45.0944 41.1429 52.5757 34.8139 52.5757 27H35.8576Z",
    fill: "#1A5AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.374 63.1429C111.991 63.1429 115.733 59.9769 115.733 56.0714C115.733 52.166 111.991 49 107.374 49C102.758 49 99.0151 52.166 99.0151 56.0714C99.0151 59.9769 102.758 63.1429 107.374 63.1429Z",
    fill: "#1A5AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.668 55.0498C226.37 55.9691 225.878 56.805 225.284 57.5572C224.691 58.3931 223.902 59.0617 222.913 59.6467C218.862 62.2377 211.551 62.4885 206.809 58.6437C203.252 55.8019 201.869 50.5364 204.042 46.1067C205.129 43.9336 207.204 41.7604 210.464 40.5067C214.219 39.0858 220.443 39.5037 223.803 42.5962C226.075 44.6858 227.26 47.8618 226.965 51.5394C226.965 51.8737 226.865 52.1245 226.865 52.1245H209.476C209.476 53.211 210.069 54.1304 210.761 54.8826C211.65 55.8855 213.428 56.7214 215.207 56.805C216.59 56.8886 218.171 56.6378 219.258 55.9691C220.148 55.3841 220.74 54.6318 221.134 53.7126L226.668 55.0498ZM220.443 48.3633C220.443 46.8589 219.258 45.438 217.874 44.8528C216.096 44.1008 213.824 44.1842 212.243 44.9364C210.761 45.6051 209.674 46.8589 209.575 48.4469C212.045 48.4469 214.515 48.4469 216.985 48.4469C218.171 48.3633 219.258 48.3633 220.443 48.3633Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.107 40.4233V35.7428L147.035 34.2383V40.4233H151.975V45.3546H147.035V53.9634C147.035 54.8828 147.232 55.4678 147.726 55.8021C148.22 56.1365 148.912 56.3037 149.9 56.3037C150.295 56.3037 150.69 56.3037 151.086 56.3037C151.481 56.3037 151.777 56.2201 151.975 56.1365V60.7334C151.678 60.817 151.184 60.9842 150.591 61.0678C149.999 61.1514 149.208 61.235 148.22 61.235C145.849 61.235 143.972 60.6498 142.589 59.5633C141.205 58.4768 140.514 56.8887 140.514 54.8828V45.3546H136.167V40.4233H141.107Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.031 45.9395C170.45 45.7723 168.178 45.3544 165.609 47.026C165.016 47.444 164.621 48.029 164.226 48.7813C163.93 49.5333 163.732 50.4528 163.732 51.5394V60.9004H157.112V40.4231H163.534C163.534 41.4261 163.534 42.3455 163.534 43.3485C163.831 43.0141 164.127 42.5962 164.423 42.2619C164.918 41.844 165.411 41.5097 165.905 41.1754C167.486 40.3395 169.363 40.1724 171.142 40.256C171.34 40.256 171.636 40.256 171.932 40.3395V45.9395H172.031Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.989 40.4231H198.608V60.984H192.186V58.4767C191.396 59.5631 190.408 60.3154 189.124 60.8168C186.16 61.9869 182.306 61.8199 179.738 60.1482C177.268 58.5601 176.477 55.9691 176.477 53.4618V40.4231H183.097V52.3751C183.097 54.5482 184.579 56.3035 187.246 56.3871C188.63 56.3871 189.914 56.0527 190.803 55.2169C191.791 54.381 192.088 53.2946 192.088 52.1245C191.989 52.2917 191.989 40.4231 191.989 40.4231Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M239.906 45.1873V60.984H233.288V45.1873H229.236V40.4232H233.288C233.288 38.3336 233.089 36.2441 234.274 34.3217C235.164 32.8173 236.646 31.6471 238.524 30.9785C239.611 30.6442 240.796 30.477 242.178 30.477C242.871 30.477 243.562 30.477 244.155 30.5606C244.747 30.6442 245.241 30.7278 245.44 30.8949V35.4919C245.241 35.4083 245.044 35.4083 244.747 35.3247C243.66 35.1576 242.377 35.2411 241.389 35.7426C240.4 36.2441 240.005 37.1635 240.005 38.0829V40.3396H256.307V60.9004H249.787V45.1873H239.906Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M257 33.5697C257 32.6503 256.506 31.7309 255.813 31.1458C255.122 30.5608 254.035 30.1429 252.949 30.1429C251.862 30.1429 250.775 30.5608 250.084 31.1458C249.391 31.7309 248.897 32.6503 248.897 33.5697C248.897 34.4891 249.391 35.4084 250.084 35.9935C250.775 36.5786 251.862 36.9965 252.949 36.9965C254.035 36.9965 255.122 36.5786 255.813 35.9935C256.506 35.4084 257 34.5726 257 33.5697Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5953_7146_clip_path",
    transform: "translate(67.8693 67.8693)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group (6).c77367e0e6562019916ae0807fbf597c.svg";
export { ForwardRef as ReactComponent };